import HeroSection from '@/components/degen/HeroSection';
import { BentoGrid, BentoItem, BentoCTA, BentoStats } from '@/components/degen/BentoGrid';
import { useConfig } from '@/hooks/useConfig';
import { usePrices } from '@/hooks/usePrices';

export default function HomePage() {
    const { config } = useConfig();
    const { prices } = usePrices();

    // Get the primary crypto price for display
    const primaryPrice = prices[0];

    return (
        <div className="relative">
            {/* Hero */}
            <HeroSection />

            {/* Bento Section */}
            <section className="py-20 px-4 md:px-8 max-w-7xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold font-display text-center mb-12">
                    <span className="gradient-text">WHY TRUST THE KING?</span>
                </h2>

                <BentoGrid>
                    {/* Live Price Widget */}
                    <BentoItem className="p-6">
                        <div className="h-full flex flex-col justify-between">
                            <div>
                                <p className="text-zinc-500 text-sm mb-2">LIVE MARKET</p>
                                {primaryPrice ? (
                                    <>
                                        <p className="text-3xl font-bold text-white font-display">
                                            ${primaryPrice.price.toLocaleString()}
                                        </p>
                                        <p className={`text-sm mt-1 ${primaryPrice.change24h >= 0 ? 'text-neon-green' : 'text-red-500'
                                            }`}>
                                            {primaryPrice.change24h >= 0 ? '▲' : '▼'} {Math.abs(primaryPrice.change24h).toFixed(2)}% (24h)
                                        </p>
                                    </>
                                ) : (
                                    <p className="text-zinc-400">Loading...</p>
                                )}
                            </div>
                            <p className="text-zinc-600 text-xs mt-4">
                                {primaryPrice?.symbol || 'BTC'} / USD
                            </p>
                        </div>
                    </BentoItem>

                    {/* Track Record */}
                    <BentoStats
                        stats={[
                            { label: 'CALLS MADE', value: '847' },
                            { label: 'WIN RATE', value: '87%' },
                            { label: 'AVG GAIN', value: '+420%' },
                            { label: 'MEMBERS', value: '10K+' },
                        ]}
                    />

                    {/* Join CTA */}
                    <BentoCTA
                        title="Join the Alpha"
                        description="Get exclusive access to private calls, market analysis, and early alerts."
                        buttonText="🚀 JOIN TELEGRAM"
                        onClick={() => window.open(config.socials?.telegram || '#', '_blank')}
                    />

                    {/* Testimonial */}
                    <BentoItem span="wide" className="p-8">
                        <div className="flex items-start gap-4">
                            <div className="w-12 h-12 rounded-full bg-neon-purple/30 flex items-center justify-center text-2xl">
                                🐸
                            </div>
                            <div className="flex-1">
                                <p className="text-white text-lg italic mb-4">
                                    "Followed one call, turned 0.5 SOL into 50. This guy is a legend."
                                </p>
                                <p className="text-zinc-500 text-sm">
                                    @anon_degen • Telegram Member
                                </p>
                            </div>
                        </div>
                    </BentoItem>

                    {/* Featured Coin */}
                    <BentoItem className="p-6 relative overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-br from-neon-green/10 to-transparent" />
                        <div className="relative z-10">
                            <p className="text-neon-green text-xs font-bold mb-2">🔥 HOT PICK</p>
                            <h3 className="text-2xl font-bold text-white font-display mb-2">
                                $PEPE
                            </h3>
                            <p className="text-zinc-400 text-sm mb-4">
                                Called at $0.0000001<br />
                                Current: $0.00001
                            </p>
                            <span className="inline-block px-3 py-1 bg-neon-green/20 text-neon-green text-xs font-bold rounded-full">
                                +10,000%
                            </span>
                        </div>
                    </BentoItem>
                </BentoGrid>
            </section>

            {/* Footer CTA */}
            <section className="py-20 px-4 text-center">
                <h2 className="text-4xl md:text-5xl font-bold font-display mb-6">
                    <span className="text-white">READY TO </span>
                    <span className="text-neon-green neon-glow">APE?</span>
                </h2>
                <p className="text-zinc-400 mb-8 max-w-xl mx-auto">
                    Stop missing 100x gems. Join the inner circle and get alpha before it hits CT.
                </p>
                <button className="btn-primary text-xl animate-glow-pulse">
                    JOIN NOW - IT'S FREE
                </button>
            </section>
        </div>
    );
}
